import { db } from "@/firebase/config"
import { query, collection, getDocs, } from "firebase/firestore"
import addMockAuthUsers from "./add_auth_users"
import addMockBlogs from "./add_blogs"
import addMockAccessRequests from "./add_access_requests"
import addMockNominations from "./add_nominations"

const addMocks = () => {
    const addMock = async () => {
        const usersRef = query(collection(db, 'Users'))
        const usersDocs = await getDocs(usersRef)
        
        if (usersDocs.docs.length > 0) {
            console.log('We already have mocks. Not adding more.')
            return false
        }
        
        // Now we can add the auth users.
        const mockAuth = addMockAuthUsers()
        await mockAuth.addUsers()

        // Now we add the blogs.
        const mockBlogs = addMockBlogs()
        await mockBlogs.addBlogs()

        // Now we add the Access Requests.
        const mockAccess = addMockAccessRequests()
        await mockAccess.addRequests()

        // Now we add the mock nominations.
        const mockNoms = addMockNominations()
        await mockNoms.addNominations()
    }

    return { addMock }
}

export default addMocks
